export default __webpack_public_path__ + "static/media/logo.11158472.png";